// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid-module--grid--3mj70","header":"grid-module--header--G3Fjm","main":"grid-module--main--1zBtO","footer":"grid-module--footer--2aSxp"};